export default {
    props: {
        scrollableVirtual: {
            type: Boolean,
            default: undefined,
            kComposite: 'scrollable.virtual'
        }, 
        scrollableEndless: {
            type: Boolean,
            default: undefined,
            kComposite: 'scrollable.endless'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Scrollable.js